//ClientLibsReference
import firebase from "firebase";
import { CloudService } from "./ClientLibsReference";
import * as logger from "../Feedback/Log";
import * as Constant from "../config/Configuration";

var api1 = new CloudService.DefaultApi();
export const api = (name, o) => {
  var opts = {
    body: o
  };

  //Authorization
  var defaultClient = CloudService.ApiClient.instance;

  //Api Key
  defaultClient.authentications["api_key"].apiKey = Constant.getApiKey();

  //Firebase
  defaultClient.authentications["firebase"].accessToken = localStorage.getItem(
    "firebaseIdToken"
  );

  logger.info(
    "Security Token [" + localStorage.getItem("firebaseIdToken") + "]"
  );
  logger.info(`Called API: ${name}`);
  return new Promise((resolve, reject) => {
    var callback = function(error, data, response) {
      if (error) {
        logger.info(`[${name}] Got error: ${error}`);
        resolve(error);
      } else {
        // Failed due to firebaseIdToken being expired
        if (data.errorCode === 9998) {
          // Check for rememberMe flag
          if (localStorage.getItem("rememberMe")) {
            // If true refresh token
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then(idToken => {
                localStorage.setItem("firebaseIdToken", idToken);
              });
          } else {
            // If false clear storage and sign out
            localStorage.clear();
            window.location = "#/";
          }
        } else {
          resolve({ data });
        }
      }
    };
    api1[name](opts, callback);
  });
};



// WEBPACK FOOTER //
// ./src/common/CloudService/ApiPromisify.js